import { Table as TableComponent, TableProps } from "@heroui/react";

// use `even:bg-default-100` in tr to make the table striped
export const Table = ({ className, ...props }: TableProps) => {
    return (
        <TableComponent
            shadow="none"
            radius="md"
            className={`overflow-y-auto border rounded-xl border-divider ${className}`}
            {...props}
        />
    );
};
